
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

interface BusinessTabsHeaderProps {
  activeTab: string;
  isMobile: boolean;
}

const BusinessTabsHeader = ({
  activeTab,
  isMobile
}: BusinessTabsHeaderProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
      {/* Mobile layout - tabs only */}
      {isMobile ? (
        <div className="flex flex-col space-y-4 w-full">
          <TabsList className="bg-muted/50 w-full grid grid-cols-2 rounded-full p-1">
            <TabsTrigger value="billing" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
              Billing
            </TabsTrigger>
            <TabsTrigger value="users" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
              Members
            </TabsTrigger>
          </TabsList>
        </div>
      ) : (
        <div className="flex flex-row w-full">
          {/* Desktop layout - Tabs only, business dropdown removed */}
          <TabsList className="bg-muted/50 w-auto inline-flex rounded-full p-1">
            <TabsTrigger value="billing" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
              Billing
            </TabsTrigger>
            <TabsTrigger value="users" className="rounded-full data-[state=active]:bg-white data-[state=active]:text-foreground px-6">
              Members
            </TabsTrigger>
          </TabsList>
        </div>
      )}
    </div>
  );
};

export default BusinessTabsHeader;
